import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {ListaComponent} from "./lista/lista.component";
import {AtendimentoDetalhesPaginaComponent} from "./atendimento-detalhes-pagina/atendimento-detalhes-pagina.component";

const routes: Routes = [
  { path: "", component: ListaComponent },
  { path: "detalhes/:id", component: AtendimentoDetalhesPaginaComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AtendimentoRoutingModule { }
